
// Función genérica para manejar los popups
function handlePopup(openButtonId, popupId, closeIconSelector) {
  const popup = document.getElementById(popupId);
  const openButton = document.getElementById(openButtonId);
  const closeIcon = document.getElementById(closeIconSelector);

  // Mostrar u ocultar el popup
  function togglePopup() {
    popup.classList.toggle("show");
  }

  // Cerrar el popup
  function closePopup() {
    popup.classList.remove("show");
  }

  // Asignar eventos
  openButton.addEventListener('click', togglePopup);
  closeIcon.addEventListener('click', closePopup);
}

// Llamadas para inicializar los popups
handlePopup('open-vet-id-popup', 'vet-id-popup', 'close-vet-pop-up');
handlePopup('open-food-chart-popup', 'food-chart-popup', 'close-food-chart-pop-up');
handlePopup('zoom-img', 'modal-zoom-img', 'close-zoom-pop-up');

